// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagesContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 30px;
}

.page-btn {
    margin: 20px;
    background-image: linear-gradient(to right, #44aceb 0%, #3762f0 51%, #368cdc 100%);
    text-align: center;
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 10px;
    color: white;
    padding: 10px;
    width: 180px;
    height: 180px;
    font-weight: 700;
    font-size: 20pt;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.page-btn-num {
    background-color: red;
    color: white;
    border-radius: 20px;
    width: 90%;
    font-weight: 700;
    font-size: 15pt;
    margin-top: 12px;
    padding: 3px;
}

.pagesBtnsContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 600px;
    flex-wrap: wrap;

}


.pagesContainerContainer {
    background-color: #ffffff;
    padding: 0px 40px 40px 40px;
    border-radius: 8px;
    direction: rtl;
    margin: 50px;
    height: 85vh;
}


.PagesNavigationContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f1f7ff;
    height: 100vh;
    /* padding: 100px; */
}

.pagesContainerTitle {
    font-weight: 700;
    margin-bottom: 50px;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;
    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 20%;
    padding: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/pagesNavigate/pagesNavigate.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,eAAe;;AAEnB;;;AAGA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gCAAgC;IAChC,iCAAiC;IACjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;AAChB","sourcesContent":[".pagesContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-direction: column;\r\n    margin: 30px;\r\n}\r\n\r\n.page-btn {\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #44aceb 0%, #3762f0 51%, #368cdc 100%);\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 10px;\r\n    color: white;\r\n    padding: 10px;\r\n    width: 180px;\r\n    height: 180px;\r\n    font-weight: 700;\r\n    font-size: 20pt;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.page-btn-num {\r\n    background-color: red;\r\n    color: white;\r\n    border-radius: 20px;\r\n    width: 90%;\r\n    font-weight: 700;\r\n    font-size: 15pt;\r\n    margin-top: 12px;\r\n    padding: 3px;\r\n}\r\n\r\n.pagesBtnsContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    height: 600px;\r\n    flex-wrap: wrap;\r\n\r\n}\r\n\r\n\r\n.pagesContainerContainer {\r\n    background-color: #ffffff;\r\n    padding: 0px 40px 40px 40px;\r\n    border-radius: 8px;\r\n    direction: rtl;\r\n    margin: 50px;\r\n    height: 85vh;\r\n}\r\n\r\n\r\n.PagesNavigationContainer {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #f1f7ff;\r\n    height: 100vh;\r\n    /* padding: 100px; */\r\n}\r\n\r\n.pagesContainerTitle {\r\n    font-weight: 700;\r\n    margin-bottom: 50px;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 20%;\r\n    padding: 8px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
